import { isPlatformServer } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, isDevMode, PLATFORM_ID } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServerRendering } from '@angular/platform-server';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthInterceptor } from '@app/core/interceptors/auth.interceptor';
import { GraphQLModule } from '@app/graphql.module';
// import { NgxSsrCacheModule } from '@ngx-ssr/cache';
import { Attributes, IntersectionObserverHooks, LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule } from 'ng-lazyload-image';
import { routes } from './app.routes';

class LazyLoadImageHooks extends IntersectionObserverHooks {
  override skipLazyLoading(attributes: Attributes) {
    return isPlatformServer(inject(PLATFORM_ID));
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideServerRendering(),
    provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    importProvidersFrom(BrowserModule),
    // importProvidersFrom(NgxSsrCacheModule.configLruCache({ maxAge: 10 * 60_000, maxSize: 30 })),
    importProvidersFrom(LazyLoadImageModule),
    importProvidersFrom(GraphQLModule),
    importProvidersFrom(ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })),
    {
      provide: LAZYLOAD_IMAGE_HOOKS,
      useClass: LazyLoadImageHooks,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ]
};
